module.exports = __webpack_public_path__ + "images/12-04@2x_89ad492f.png";